import React from 'react';

import indotechLogo from '../../assets/logos/indotechLogoDark_v2.png';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import FooterAddress from './FooterAddress';
import FooterContact from './FooterContact';
import FooterMediaLinks from './FooterMediaLinks';
import FooterOfficeHours from './FooterOfficeHours';

function Footer() {
    const { isMobile } = useWindowDimensions();

    return (
        <footer className={'w-full border-t border-white/30 bg-indotech-primary_blue'}>
            <div className={`px-8 py-10 ${isMobile ? 'flex flex-col gap-10' : 'grid grid-cols-4'}`}>
                <div className={'flex items-center justify-center sm:justify-start'}>
                    <img
                        src={indotechLogo}
                        alt={'Indotech'}
                        className={'h-full max-h-16 object-contain sm:max-h-20'}
                    />
                </div>

                <FooterContact />

                <FooterAddress />

                <FooterOfficeHours />
            </div>

            <div className={'flex w-full flex-row items-center justify-between border-t border-white/20 px-8 py-3'}>
                <div className={'text-sm text-white sm:text-lg'}>@Indotech 2004-2024</div>

                <FooterMediaLinks />
            </div>
        </footer>
    );
}

export default Footer;
